"use strict";

angular.module("vendor")
.service("PartnershipService", function(
    $resource, $http, FlashBag, gettextCatalog, TAGS_INPUT_VALIDATION_REGEX, appConfig
) {
    var partnershipEditService = $resource(appConfig.API_SERVER + "/auth/vendor/partnerships/:id/", {
        id: "@id"
    }, {
        get: {
            method: "GET",
            isArray: false,
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        },
        save: {
            method: "POST",
        },
        update: {
            method: "PUT",
        },
        delete: {
            method: "DELETE",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });

    function getFilterValues() {
        return {
            disabled: gettextCatalog.getString("Disabled Status Filter"),
            rejected: gettextCatalog.getString("Rejected Status Filter"),
            requested: gettextCatalog.getString("Requested Status Filter"),
            prospect: gettextCatalog.getString("Prospect Status Filter"),
            invited: gettextCatalog.getString("Invited Status Filter"),
            valid: gettextCatalog.getString("Valid Status Filter"),
            has_ordered: gettextCatalog.getString("Has Ordered Status Filter")
        }
    }

    function getFilter() {
        var values = [];
        var filterValues = getFilterValues();

        angular.forEach(filterValues, function(value, key) {
            values.push({
                Value: key,
                Name: value
            });
        });

        return values;
    }

    this.get = function(id) {
        var params = {id: id};
        return partnershipEditService.get(params);
    };

    this.add = function(data) {
        var partnership = new partnershipEditService(data);
        return partnership.$save();
    };

    this.update = function(data) {
        return data.$update();
    };

    this.delete = function(id) {
        return partnershipEditService.delete({id: id}).$promise;
    };

    this.importCustomers = function(data) {
        return $http.post(appConfig.API_SERVER + "/import/partnerships/", data, {
            transformRequest: angular.identity,
            headers: {"Content-Type": undefined}
        });
    };

    this.updateOrCreateCustomersInBatch = function(data) {
        return $http.post(
            appConfig.API_SERVER + "/catalog/vendor/partnership-batch/",
            {"data_form": data}
        );
    };

    this.importDeliveryRules = function(data) {
        return $http.post(appConfig.API_SERVER + "/import/delivery-rules/", data, {
            transformRequest: angular.identity,
            headers: {"Content-Type": undefined}
        })
    };

    this.importPreferred = function(data) {
        return $http.post(appConfig.API_SERVER + "/import/preferred/", data, {
            transformRequest: angular.identity,
            headers: {"Content-Type": undefined}
        })
    };

    this.queryTags = function(query) {
        if (!TAGS_INPUT_VALIDATION_REGEX.test(query))
            return [];

        var params = {
            search: query
        };
        var resource = $resource(appConfig.API_SERVER + "/auth/vendor/partnerships/tags/:search/", {
            search: "search"
        }, {
            query: {method: "GET", isArray: true, ignoreLoadingBar: true}
        });
        return resource.query(params).$promise;
    };

    this.createManager = function(partnershipId, data) {
        return $http.post(appConfig.API_SERVER + "/auth/vendor/partnerships/" + partnershipId + "/user-customers/", data);
    };

    this.reSendManagerInvitation = function(partnershipId, userCustomerId) {
        return $http.post(appConfig.API_SERVER + "/auth/vendor/partnerships/" + partnershipId + "/user-customers/" + userCustomerId + "/send-invitation/");
    };

    this.getStatusHtmlContent = function() {
        return gettextCatalog.getString("Status help tip html");
    };

    this.getSalesRepStatusHtmlContent = function() {
        return gettextCatalog.getString("Sales rep status help tip html");
    };

    this.getFinancialStatusHtmlContent = function() {
        return gettextCatalog.getString("Financial status help tip html");
    };

    this.isStatusValidForManagerCreation = function(status) {
        return ['valid', 'has_ordered'].indexOf(status) >= 0;
    };

    this.getFilter = getFilter;

    this.getFilterValues = getFilterValues;
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/customer/partnership.service.js
// module id = 866
// module chunks = 0